import { createReducer, on } from '@ngrx/store'
import * as Actions from '@store/actions/loader.actions'

export default createReducer(
    undefined,
    on(Actions.showLoader, state => ({ ...state, isShowing: true })),
    on(Actions.hideLoader, state => ({ ...state, isShowing: false }))
)
